import dynamic from "next/dynamic";
import {
  parcelDetailsSchemaGe,
  parcelItemsSchemaGe,
} from "@/validations/parcel/parcelStepsGe.validation";
import {
  parcelServicesSchema,
  parcelShippingMethodSchema,
  receiverInfoSchema,
  senderInfoSchema,
  shipmentCreateSchema,
  shipmentDetailsSchema,
  shippingOptionsSchema,
} from "@/validations/parcel/parcelSteps.validation";

const ShippingMethod = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/shipping-method"
    ),
  { ssr: false },
);
const ParcelItemsGE = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/ge/parcel-items-ge"
    ),
  { ssr: false },
);
const ParcelDetailsGE = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/ge/parcel-details-ge"
    ),
  { ssr: false },
);
const ParcelServices = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/parcel-services"
    ),
  { ssr: false },
);

const ShipmentSenderInfo = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/shipment-sender-info"
    ),
  { ssr: false },
);
const ShipmentDetails = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/shipment-details"
    ),
  { ssr: false },
);
const ShipmentReceiverInfo = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/shipment-receiver-info"
    ),
  { ssr: false },
);
const ShipmentOptions = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/shipment-options"
    ),
  { ssr: false },
);

export const getParcelGE = [
  {
    stepName: "add_parcel",
    component: <ShippingMethod />,
    validationSchema: parcelShippingMethodSchema,
  },
  {
    stepName: "parcel_details",
    component: <ParcelDetailsGE />,
    validationSchema: parcelDetailsSchemaGe,
  },
  {
    stepName: "item_details",
    component: <ParcelItemsGE />,
    validationSchema: parcelItemsSchemaGe,
  },
  {
    stepName: "addon_services",
    component: <ParcelServices />,
    validationSchema: parcelServicesSchema,
  },
];

export const sendParcelGe = [
  {
    stepName: "create_shipment",
    component: <ShippingMethod />,
    validationSchema: shipmentCreateSchema,
  },
  {
    stepName: "sender_information",
    component: <ShipmentSenderInfo />,
    validationSchema: senderInfoSchema,
  },
  {
    stepName: "shipment_details",
    component: <ShipmentDetails />,
    validationSchema: shipmentDetailsSchema,
  },
  {
    stepName: "receiver_information",
    component: <ShipmentReceiverInfo />,
    validationSchema: receiverInfoSchema,
  },
  {
    stepName: "shipping_options_addon_services",
    component: <ShipmentOptions />,
    validationSchema: shippingOptionsSchema,
  },
];
